import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HostService } from '../host/host.service';

@Injectable({
	providedIn: 'root'
})
export class LogrosService {

	host = this.hostService.host;
	logros = 'logros/actualizar/'
	nuevoLogro = 'logros/agregar/'
	constructor(public http: HttpClient, public hostService: HostService) { }

	actualizarLogro(codigo: any, data: any): Promise<any> {

		return new Promise((resolve, reject) => {
			this.http.put(`${this.host}${this.logros}${codigo}`, data)
				.subscribe(
					data => {
						resolve(data);
					},
					error => {
						reject(error);
					}
				)
		})
	}

	crearLogro(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
			this.http.post(`${this.host}${this.nuevoLogro}`, data)
				.subscribe(
					data => {
						resolve(data);
					},
					error => {
						reject(error);
					}
				)
		})
	}

}
